/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Declined_ToastInputs */

const en_booking_declined_toast = /** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking declined and refund initiated`)
};

const es_booking_declined_toast = /** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva rechazada y reembolso iniciado`)
};

const fr_booking_declined_toast = /** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservation refusée et remboursement initié`)
};

const de_booking_declined_toast = /** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchung abgelehnt und Rückerstattung eingeleitet`)
};

const id_booking_declined_toast = /** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemesanan ditolak dan pengembalian dana diproses`)
};

/** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */
const ja_booking_declined_toast = en_booking_declined_toast;

/** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */
const zh_booking_declined_toast = en_booking_declined_toast;

/** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */
const ar_booking_declined_toast = en_booking_declined_toast;

/** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */
const it_booking_declined_toast = en_booking_declined_toast;

/** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */
const ru_booking_declined_toast = en_booking_declined_toast;

/** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */
const pt_booking_declined_toast = en_booking_declined_toast;

/** @type {(inputs: Booking_Declined_ToastInputs) => LocalizedString} */
const ko_booking_declined_toast = en_booking_declined_toast;

/**
* | output |
* | --- |
* | "Booking declined and refund initiated" |
*
* @param {Booking_Declined_ToastInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_declined_toast = /** @type {((inputs?: Booking_Declined_ToastInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Declined_ToastInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_declined_toast(inputs)
	if (locale === "es") return es_booking_declined_toast(inputs)
	if (locale === "fr") return fr_booking_declined_toast(inputs)
	if (locale === "de") return de_booking_declined_toast(inputs)
	if (locale === "ja") return ja_booking_declined_toast(inputs)
	if (locale === "zh") return zh_booking_declined_toast(inputs)
	if (locale === "ar") return ar_booking_declined_toast(inputs)
	if (locale === "id") return id_booking_declined_toast(inputs)
	if (locale === "it") return it_booking_declined_toast(inputs)
	if (locale === "ru") return ru_booking_declined_toast(inputs)
	if (locale === "pt") return pt_booking_declined_toast(inputs)
	return ko_booking_declined_toast(inputs)
});